import { PropsWithChildren } from "react";
import { Colour } from "../../Variables";

export type CardProps = {
    title: string,
    headerTheme: Colour,
    headerClasses: string
}

export function Card(props: PropsWithChildren<CardProps>) {
    return (
        <div className={`card card-${props.headerTheme} shadow mt-3 ${props.headerClasses}`}>
            <div className="card-header no-highlight">{props.title}</div>
            <div className="card-body">
                {props.children}
            </div>
        </div>
    );
}